// extracted by mini-css-extract-plugin
module.exports = {"icomoon-font":"Breadcrumbs_icomoon-font__ZfV3B","Breadcrumbs":"Breadcrumbs_Breadcrumbs__3q6ud","BreadcrumbItem":"Breadcrumbs_BreadcrumbItem__q3g4b"};